'use strict';

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var debug = require('debug');

var log = Object.assign(debug('libp2p:dialer'), {
  error: debug('libp2p:dialer:err')
});

var errCode = require('err-code');

var _require = require('multiaddr'),
    Multiaddr = _require.Multiaddr; // @ts-ignore timeout-abourt-controles does not export types


var TimeoutController = require('timeout-abort-controller');

var _require2 = require('abortable-iterator'),
    AbortError = _require2.AbortError;

var _require3 = require('any-signal'),
    anySignal = _require3.anySignal;

var DialRequest = require('./dial-request');

var _require4 = require('libp2p-utils/src/address-sort'),
    publicAddressesFirst = _require4.publicAddressesFirst;

var getPeer = require('../get-peer');

var _require5 = require('../errors'),
    codes = _require5.codes;

var _require6 = require('../constants'),
    DIAL_TIMEOUT = _require6.DIAL_TIMEOUT,
    MAX_PARALLEL_DIALS = _require6.MAX_PARALLEL_DIALS,
    MAX_PER_PEER_DIALS = _require6.MAX_PER_PEER_DIALS,
    MAX_ADDRS_TO_DIAL = _require6.MAX_ADDRS_TO_DIAL;
/**
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('../peer-store')} PeerStore
 * @typedef {import('../peer-store/address-book').Address} Address
 * @typedef {import('../transport-manager')} TransportManager
 */

/**
 * @typedef {Object} DialerProperties
 * @property {PeerStore} peerStore
 * @property {TransportManager} transportManager
 *
 * @typedef {(addr:Multiaddr) => Promise<string[]>} Resolver
 *
 * @typedef {Object} DialerOptions
 * @property {(addresses: Address[]) => Address[]} [options.addressSorter = publicAddressesFirst] - Sort the known addresses of a peer before trying to dial.
 * @property {number} [maxParallelDials = MAX_PARALLEL_DIALS] - Number of max concurrent dials.
 * @property {number} [maxAddrsToDial = MAX_ADDRS_TO_DIAL] - Number of max addresses to dial for a given peer.
 * @property {number} [maxDialsPerPeer = MAX_PER_PEER_DIALS] - Number of max concurrent dials per peer.
 * @property {number} [dialTimeout = DIAL_TIMEOUT] - How long a dial attempt is allowed to take.
 * @property {Record<string, Resolver>} [resolvers = {}] - multiaddr resolvers to use when dialing
 *
 * @typedef DialTarget
 * @property {string} id
 * @property {Multiaddr[]} addrs
 *
 * @typedef PendingDial
 * @property {DialRequest} dialRequest
 * @property {TimeoutController} controller
 * @property {Promise<Connection>} promise
 * @property {function():void} destroy
 */


var Dialer = /*#__PURE__*/function () {
  /**
   * @class
   * @param {DialerProperties & DialerOptions} options
   */
  function Dialer(_ref) {
    var transportManager = _ref.transportManager,
        peerStore = _ref.peerStore,
        _ref$addressSorter = _ref.addressSorter,
        addressSorter = _ref$addressSorter === void 0 ? publicAddressesFirst : _ref$addressSorter,
        _ref$maxParallelDials = _ref.maxParallelDials,
        maxParallelDials = _ref$maxParallelDials === void 0 ? MAX_PARALLEL_DIALS : _ref$maxParallelDials,
        _ref$maxAddrsToDial = _ref.maxAddrsToDial,
        maxAddrsToDial = _ref$maxAddrsToDial === void 0 ? MAX_ADDRS_TO_DIAL : _ref$maxAddrsToDial,
        _ref$dialTimeout = _ref.dialTimeout,
        dialTimeout = _ref$dialTimeout === void 0 ? DIAL_TIMEOUT : _ref$dialTimeout,
        _ref$maxDialsPerPeer = _ref.maxDialsPerPeer,
        maxDialsPerPeer = _ref$maxDialsPerPeer === void 0 ? MAX_PER_PEER_DIALS : _ref$maxDialsPerPeer,
        _ref$resolvers = _ref.resolvers,
        resolvers = _ref$resolvers === void 0 ? {} : _ref$resolvers;

    _classCallCheck(this, Dialer);

    this.transportManager = transportManager;
    this.peerStore = peerStore;
    this.addressSorter = addressSorter;
    this.maxParallelDials = maxParallelDials;
    this.maxAddrsToDial = maxAddrsToDial;
    this.timeout = dialTimeout;
    this.maxDialsPerPeer = maxDialsPerPeer;
    this.tokens = _toConsumableArray(new Array(maxParallelDials)).map(function (_, index) {
      return index;
    });
    this._pendingDials = new Map();
    this._pendingDialTargets = new Map();

    for (var _i = 0, _Object$entries = Object.entries(resolvers); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      Multiaddr.resolvers.set(key, value);
    }
  }
  /**
   * Clears any pending dials
   */


  _createClass(Dialer, [{
    key: "destroy",
    value: function destroy() {
      var _iterator = _createForOfIteratorHelper(this._pendingDials.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var dial = _step.value;

          try {
            dial.controller.abort();
          } catch (err) {
            log.error(err);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._pendingDials.clear();

      var _iterator2 = _createForOfIteratorHelper(this._pendingDialTargets.values()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var pendingTarget = _step2.value;
          pendingTarget.reject(new AbortError('Dialer was destroyed'));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this._pendingDialTargets.clear();
    }
    /**
     * Connects to a given `peer` by dialing all of its known addresses.
     * The dial to the first address that is successfully able to upgrade a connection
     * will be used.
     *
     * @param {PeerId|Multiaddr|string} peer - The peer to dial
     * @param {object} [options]
     * @param {AbortSignal} [options.signal] - An AbortController signal
     * @returns {Promise<Connection>}
     */

  }, {
    key: "connectToPeer",
    value: function () {
      var _connectToPeer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peer) {
        var options,
            dialTarget,
            pendingDial,
            connection,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                _context.next = 3;
                return this._createCancellableDialTarget(peer);

              case 3:
                dialTarget = _context.sent;

                if (dialTarget.addrs.length) {
                  _context.next = 6;
                  break;
                }

                throw errCode(new Error('The dial request has no valid addresses'), codes.ERR_NO_VALID_ADDRESSES);

              case 6:
                pendingDial = this._pendingDials.get(dialTarget.id) || this._createPendingDial(dialTarget, options);
                _context.prev = 7;
                _context.next = 10;
                return pendingDial.promise;

              case 10:
                connection = _context.sent;
                log('dial succeeded to %s', dialTarget.id);
                return _context.abrupt("return", connection);

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](7);

                // Error is a timeout
                if (pendingDial.controller.signal.aborted) {
                  _context.t0.code = codes.ERR_TIMEOUT;
                }

                log.error(_context.t0);
                throw _context.t0;

              case 20:
                _context.prev = 20;
                pendingDial.destroy();
                return _context.finish(20);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 15, 20, 23]]);
      }));

      function connectToPeer(_x) {
        return _connectToPeer.apply(this, arguments);
      }

      return connectToPeer;
    }()
    /**
     * Connects to a given `peer` by dialing all of its known addresses.
     * The dial to the first address that is successfully able to upgrade a connection
     * will be used.
     *
     * @param {PeerId|Multiaddr|string} peer - The peer to dial
     * @returns {Promise<DialTarget>}
     */

  }, {
    key: "_createCancellableDialTarget",
    value: function () {
      var _createCancellableDialTarget2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(peer) {
        var _this = this;

        var id, cancellablePromise, dialTarget;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Make dial target promise cancellable
                id = "".concat(parseInt(String(Math.random() * 1e9), 10).toString() + Date.now());
                cancellablePromise = new Promise(function (resolve, reject) {
                  _this._pendingDialTargets.set(id, {
                    resolve: resolve,
                    reject: reject
                  });
                });
                _context2.next = 4;
                return Promise.race([this._createDialTarget(peer), cancellablePromise]);

              case 4:
                dialTarget = _context2.sent;

                this._pendingDialTargets.delete(id);

                return _context2.abrupt("return", dialTarget);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _createCancellableDialTarget(_x2) {
        return _createCancellableDialTarget2.apply(this, arguments);
      }

      return _createCancellableDialTarget;
    }()
    /**
     * Creates a DialTarget. The DialTarget is used to create and track
     * the DialRequest to a given peer.
     * If a multiaddr is received it should be the first address attempted.
     * Multiaddrs not supported by the available transports will be filtered out.
     *
     * @private
     * @param {PeerId|Multiaddr|string} peer - A PeerId or Multiaddr
     * @returns {Promise<DialTarget>}
     */

  }, {
    key: "_createDialTarget",
    value: function () {
      var _createDialTarget2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(peer) {
        var _this2 = this;

        var _getPeer, id, multiaddrs, knownAddrs, addrs, _iterator3, _step3, a, resolvedAddrs, supportedAddrs;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _getPeer = getPeer(peer), id = _getPeer.id, multiaddrs = _getPeer.multiaddrs;

                if (multiaddrs) {
                  this.peerStore.addressBook.add(id, multiaddrs);
                }

                knownAddrs = this.peerStore.addressBook.getMultiaddrsForPeer(id, this.addressSorter) || []; // If received a multiaddr to dial, it should be the first to use
                // But, if we know other multiaddrs for the peer, we should try them too.

                if (Multiaddr.isMultiaddr(peer)) {
                  knownAddrs = knownAddrs.filter(function (addr) {
                    return !peer.equals(addr);
                  });
                  knownAddrs.unshift(peer);
                }
                /** @type {Multiaddr[]} */


                addrs = [];
                _iterator3 = _createForOfIteratorHelper(knownAddrs);
                _context3.prev = 6;

                _iterator3.s();

              case 8:
                if ((_step3 = _iterator3.n()).done) {
                  _context3.next = 16;
                  break;
                }

                a = _step3.value;
                _context3.next = 12;
                return this._resolve(a);

              case 12:
                resolvedAddrs = _context3.sent;
                resolvedAddrs.forEach(function (ra) {
                  return addrs.push(ra);
                });

              case 14:
                _context3.next = 8;
                break;

              case 16:
                _context3.next = 21;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3["catch"](6);

                _iterator3.e(_context3.t0);

              case 21:
                _context3.prev = 21;

                _iterator3.f();

                return _context3.finish(21);

              case 24:
                // Multiaddrs not supported by the available transports will be filtered out.
                supportedAddrs = addrs.filter(function (a) {
                  return _this2.transportManager.transportForMultiaddr(a);
                });

                if (!(supportedAddrs.length > this.maxAddrsToDial)) {
                  _context3.next = 28;
                  break;
                }

                this.peerStore.delete(id);
                throw errCode(new Error('dial with more addresses than allowed'), codes.ERR_TOO_MANY_ADDRESSES);

              case 28:
                return _context3.abrupt("return", {
                  id: id.toB58String(),
                  addrs: supportedAddrs
                });

              case 29:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 18, 21, 24]]);
      }));

      function _createDialTarget(_x3) {
        return _createDialTarget2.apply(this, arguments);
      }

      return _createDialTarget;
    }()
    /**
     * Creates a PendingDial that wraps the underlying DialRequest
     *
     * @private
     * @param {DialTarget} dialTarget
     * @param {object} [options]
     * @param {AbortSignal} [options.signal] - An AbortController signal
     * @returns {PendingDial}
     */

  }, {
    key: "_createPendingDial",
    value: function _createPendingDial(dialTarget) {
      var _this3 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      /**
       * @param {Multiaddr} addr
       * @param {{ signal: { aborted: any; }; }} options
       */
      var dialAction = function dialAction(addr, options) {
        if (options.signal.aborted) throw errCode(new Error('already aborted'), codes.ERR_ALREADY_ABORTED);
        return _this3.transportManager.dial(addr, options);
      };

      var dialRequest = new DialRequest({
        addrs: dialTarget.addrs,
        dialAction: dialAction,
        dialer: this
      }); // Combine the timeout signal and options.signal, if provided

      var timeoutController = new TimeoutController(this.timeout);
      var signals = [timeoutController.signal];
      options.signal && signals.push(options.signal);
      var signal = anySignal(signals);
      var pendingDial = {
        dialRequest: dialRequest,
        controller: timeoutController,
        promise: dialRequest.run(_objectSpread(_objectSpread({}, options), {}, {
          signal: signal
        })),
        destroy: function destroy() {
          timeoutController.clear();

          _this3._pendingDials.delete(dialTarget.id);
        }
      };

      this._pendingDials.set(dialTarget.id, pendingDial);

      return pendingDial;
    }
    /**
     * @param {number} num
     */

  }, {
    key: "getTokens",
    value: function getTokens(num) {
      var total = Math.min(num, this.maxDialsPerPeer, this.tokens.length);
      var tokens = this.tokens.splice(0, total);
      log('%d tokens request, returning %d, %d remaining', num, total, this.tokens.length);
      return tokens;
    }
    /**
     * @param {number} token
     */

  }, {
    key: "releaseToken",
    value: function releaseToken(token) {
      // Guard against duplicate releases
      if (this.tokens.indexOf(token) > -1) return;
      log('token %d released', token);
      this.tokens.push(token);
    }
    /**
     * Resolve multiaddr recursively.
     *
     * @param {Multiaddr} ma
     * @returns {Promise<Multiaddr[]>}
     */

  }, {
    key: "_resolve",
    value: function () {
      var _resolve2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(ma) {
        var _this4 = this;

        var resolvableProto, resolvedMultiaddrs, recursiveMultiaddrs, addrs;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // TODO: recursive logic should live in multiaddr once dns4/dns6 support is in place
                // Now only supporting resolve for dnsaddr
                resolvableProto = ma.protoNames().includes('dnsaddr'); // Multiaddr is not resolvable? End recursion!

                if (resolvableProto) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return", [ma]);

              case 3:
                _context4.next = 5;
                return this._resolveRecord(ma);

              case 5:
                resolvedMultiaddrs = _context4.sent;
                _context4.next = 8;
                return Promise.all(resolvedMultiaddrs.map(function (nm) {
                  return _this4._resolve(nm);
                }));

              case 8:
                recursiveMultiaddrs = _context4.sent;
                addrs = recursiveMultiaddrs.flat();
                return _context4.abrupt("return", addrs.reduce(function (array, newM) {
                  if (!array.find(function (m) {
                    return m.equals(newM);
                  })) {
                    array.push(newM);
                  }

                  return array;
                },
                /** @type  {Multiaddr[]} */
                []));

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _resolve(_x4) {
        return _resolve2.apply(this, arguments);
      }

      return _resolve;
    }()
    /**
     * Resolve a given multiaddr. If this fails, an empty array will be returned
     *
     * @param {Multiaddr} ma
     * @returns {Promise<Multiaddr[]>}
     */

  }, {
    key: "_resolveRecord",
    value: function () {
      var _resolveRecord2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(ma) {
        var multiaddrs;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                ma = new Multiaddr(ma.toString()); // Use current multiaddr module

                _context5.next = 4;
                return ma.resolve();

              case 4:
                multiaddrs = _context5.sent;
                return _context5.abrupt("return", multiaddrs);

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);
                log.error("multiaddr ".concat(ma, " could not be resolved"));
                return _context5.abrupt("return", []);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 8]]);
      }));

      function _resolveRecord(_x5) {
        return _resolveRecord2.apply(this, arguments);
      }

      return _resolveRecord;
    }()
  }]);

  return Dialer;
}();

module.exports = Dialer;